import { Injectable } from '@angular/core';
import { BaseApiService } from './base-api.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { FILES_APPLICATION } from '../../app.consts';
import { AuthService } from '../../services/auth.service';
import { GetAssetFileFromApplicationResponseModel } from 'src/app/models/files.model';

@Injectable()
export class FileApiService extends BaseApiService {
  constructor(private http: HttpClient, protected auth: AuthService) {
    super(auth);
  }

  getAssetFileFromApplication(
    applicationId: number,
    type: string,
    filename: string
  ): Observable<GetAssetFileFromApplicationResponseModel> {
    return this.http.get<GetAssetFileFromApplicationResponseModel>(
      `${this.apiUrl}${FILES_APPLICATION}/${applicationId}/${type}/${filename}`,
      this.authHeader
    );
  }
}
